module.exports = __webpack_public_path__ + "img/flag_un.ef7d993b.svg";